import { defaultTimezone } from "./../../constants";
import dayjs from "dayjs";
import "dayjs/locale/de";
import { Slots } from "./AddAppointment";

export interface GroupedOption {
    label: string;
    options: { label: string; value: string }[];
}
export const convertSlotsToOptions = (slots: Slots[]): GroupedOption[] => {
    const slotsMappedByDay = new Map<string, Slots[]>();
    slots.forEach((slot) => {
        const date = dayjs
            .unix(slot.date)
            .locale("de")
            .tz(defaultTimezone)
            .format("dddd DD MMM");
        const slotsOnDate = slotsMappedByDay.get(date);
        if (slotsOnDate) {
            slotsMappedByDay.set(date, [...slotsOnDate, slot]);
        } else {
            slotsMappedByDay.set(date, [slot]);
        }
    });
    const optionsList: GroupedOption[] = [];
    slotsMappedByDay.forEach((slotList, key) => {
        const option: GroupedOption = {
            label: key,
            options: [],
        };
        slotList.forEach((slot) => {
            const slotDate = dayjs
                .unix(slot.date)
                .tz(defaultTimezone)
                .format("HH:mm ");
            slot.coachesData.forEach((coach) => {
                option.options.push({
                    value: `${coach.userId}$${slot.date}`,
                    label: `${coach.username} - ${slotDate} `,
                });
            });
        });
        optionsList.push(option);
    });

    return optionsList;
};
